import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, Icon, Text, Tooltip } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import classnames from 'classnames';
import { useMemo } from 'react';
import styles from './stateBar.module.scss';
import { useCharacterCounter } from './utils/useCharacterCounter/useCharacterCounter';
/**
 * Represents a component that prints the validation error/warning messages as
 * well as character counting.
 */
export const StateBar = ({ channel, text, validation, className, isPublicReply, }) => {
    const { count, limit, messages, encoding } = useCharacterCounter({
        channel,
        text,
        isPublicReply,
    });
    const errorMessage = useMemo(() => {
        if (count == 0 && validation.touched) {
            return 'Required';
        }
        if (count > limit) {
            return `${count}/${limit} · Your message is too long`;
        }
    }, [count, limit, validation.touched]);
    const warningMessage = useMemo(() => {
        if (validation.touched && validation.warning) {
            switch (validation.warning.type) {
                case 'offline':
                    return 'The customer is offline';
                case 'file-size':
                    return `${validation.warning.arg.size}/${validation.warning.arg.maxSize} · File size is too large`;
            }
        }
    }, [validation.touched, validation.warning]);
    const messageColor = useMemo(() => {
        if (errorMessage) {
            return colors.red[600];
        }
        if (warningMessage) {
            return colors.orange[400];
        }
    }, [errorMessage, warningMessage]);
    return (_jsxs(FlexBox, Object.assign({ className: classnames(styles.root, className), alignItems: "center", gap: "200" }, { children: [channel === 'sms' && encoding === 'UTF-16' && (_jsx(Tooltip, Object.assign({ className: styles.tooltip, dark: true, content: "Special characters, such as emojis or non-Latin characters, reduce the character limit for text messages from 160 to 70, which can increase the overall text message count." }, { children: _jsx(FlexBox, { children: _jsx(Icon, { name: "info", color: messageColor }) }) }))), warningMessage && (_jsx(Text.Paragraph, Object.assign({ variant: "2", subdued: true, color: colors.orange[400] }, { children: warningMessage }))), errorMessage && (_jsx(Text.Paragraph, Object.assign({ variant: "2", subdued: true, color: colors.red[600] }, { children: errorMessage }))), !errorMessage && !warningMessage && channel === 'sms' && (_jsx(Text.Paragraph, Object.assign({ variant: "2", subdued: true }, { children: `${count}/${limit} · ${messages} text ${messages === 1 ? 'message' : 'messages'}` }))), !errorMessage && !warningMessage && channel === 'twitter' && (_jsx(Text.Paragraph, Object.assign({ variant: "2", subdued: true }, { children: `${count}/${limit}` })))] })));
};
